document.addEventListener("DOMContentLoaded", () => {
  const productDataEl = document.getElementById("ProductData");
  if (!productDataEl) return;

  let productData;

  try {
    productData = JSON.parse(productDataEl.textContent.trim());
  } catch (e) {
    console.warn("Variant filter: ProductData JSON invalid", e);
    return;
  }

  const variants = productData.variants;

  // Build map: option1 → option2 values
  const map = {};

  variants.forEach(v => {
    if (!map[v.option1]) map[v.option1] = new Set();
    map[v.option1].add(v.option2);
  });

  function getSelectedOption1() {
    const el =
      document.querySelector('.variant-picker__field[data-option-name]:first-of-type input:checked') ||
      document.querySelector('.variant-picker__field[data-option-name]:first-of-type select option:checked');

    return el ? el.value : null;
  }

  function updateOption2() {
    const opt1 = getSelectedOption1();
    if (!opt1) return;

    const valid = map[opt1] || new Set();

    const option2Field = document.querySelectorAll(
      '.variant-picker__field-wrapper'
    )[1];

    if (!option2Field) return;

    const inputs = option2Field.querySelectorAll('input, option');

    inputs.forEach(el => {
      const wrapper = el.closest('.variant-picker__option') || el;

      if (valid.has(el.value)) {
        wrapper.style.display = "";
      } else {
        wrapper.style.display = "none";
      }
    });
  }

  // Listen to BOTH events your theme uses
  document.addEventListener("variant:changed", updateOption2);
  document.addEventListener("change", updateOption2);

  // initial run
  setTimeout(updateOption2, 300);
});